export default __webpack_public_path__ + "static/media/cabbage.86a07fa8.svg";